import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center">
            <img src="/medicinpro-logo.png" alt="MedicinPRO Logo" className="h-12 w-12" />
            <div className="ml-4">
              <h1 className="text-2xl font-bold text-gray-900">MedicinPRO</h1>
              <p className="text-sm text-gray-600">Directorio de Profesionales de la Salud y Bienestar</p>
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header; 